import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>EBTA</h4>
            <p>European Brief Therapy Association</p>
            <p>Promoting solution-focused approaches across Europe and beyond.</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/about">About Us</a></li>
              <li><a href="/membership">Membership</a></li>
              <li><a href="/activities">Activities</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Resources</h4>
            <ul>
              <li><a href="/research">Research</a></li>
              <li><a href="/sf-research">Publications</a></li>
              <li><a href="/awards">Awards</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Connect</h4>
            <div className="social-links">
              <a href="https://www.facebook.com/ebta.network" target="_blank" rel="noopener noreferrer" className="social-link">Facebook</a>
            </div>
            <div className="contact-info">
              <p><a href="mailto:info@ebta.eu" className="email-link">info@ebta.eu</a></p>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 European Brief Therapy Association. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
